import { UmbMatomoOptOut } from "../components/UmbMatomoOptOut";
import type { Content } from "../entities";

export const content: Content = {
  title: 'Cookie information',
  description: 'Cookie information',
  html: ``,
  afterUpdate: (host: ShadowRoot) => {
    const matomo = new UmbMatomoOptOut(host);
    matomo.init();
  },
};
